import { render, staticRenderFns } from "./CTQPerformanceFileverfication.vue?vue&type=template&id=37877ad8"
import script from "./CTQPerformanceFileverfication.vue?vue&type=script&lang=js"
export * from "./CTQPerformanceFileverfication.vue?vue&type=script&lang=js"
import style0 from "./CTQPerformanceFileverfication.vue?vue&type=style&index=0&id=37877ad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports